module.exports = __webpack_public_path__ + "img/interception.f8e81d45.jpg";